import Description from "@/components/common/Description";
import {
	randomHappyEmoji,
	wordsOfBoost,
	wordsOfPraise,
	wordsOfSupport,
} from "../../../../../../utils/positivePatientWords";

interface Props {
	canMarkComplete: boolean; // Flag to indicate if the patient can mark the entry as complete
}

const ReadyToReview = ({ canMarkComplete }: Props) => {
	return (
		<div className="flex flex-col justify-center items-center my-4 mt-0">
			<Description>
				{canMarkComplete ? (
					<>
						{wordsOfPraise()} Your entry is complete and ready for review. You
						can mark it as complete now or wait for your doctor to review it.{" "}
						{randomHappyEmoji()}
					</>
				) : (
					<>
						{wordsOfPraise()} Your entry is complete and has been submitted for
						review by your care team. {randomHappyEmoji()}
					</>
				)}
			</Description>
		</div>
	);
};

export default ReadyToReview;
